export const ReportAnalyticsEvents = {
    // Dashboard load lifecycle
    DASHBOARD_LOAD_STARTED: 'report_dashboard_load_started',
    DASHBOARD_LOAD_COMPLETED: 'report_dashboard_load_completed',
    DASHBOARD_LOAD_FAILED: 'report_dashboard_load_failed',
    // Chart load lifecycle
    CHART_LOAD_STARTED: 'report_chart_load_started',
    CHART_LOAD_COMPLETED: 'report_chart_load_completed',
    CHART_LOAD_FAILED: 'report_chart_load_failed',
    // Session tracking
    SESSION_STARTED: 'report_session_started',
    SESSION_ENDED: 'report_session_ended',
    // Abandonment
    ABANDONED: 'report_abandoned',
    // Filter lifecycle
    FILTER_LOAD_STARTED: 'report_filter_load_started',
    FILTER_LOAD_COMPLETED: 'report_filter_load_completed',
    FILTER_LOAD_FAILED: 'report_filter_load_failed',
    FILTER_LOAD_MORE: 'report_filter_load_more',
    FILTER_SEARCH: 'report_filter_search',
    // User interactions
    DRILLDOWN_USED: 'report_drilldown_used',
    DRILLDOWN_DATA_LOADED: 'report_drilldown_data_loaded',
    FILTER_APPLIED: 'report_filter_applied',
    TABLE_PAGE_CHANGED: 'report_table_page_changed',
    TABLE_SORT_CHANGED: 'report_table_sort_changed',
    INFO_CARD_OPENED: 'report_info_card_opened',
    // Query execution
    QUERY_EXECUTED: 'report_query_executed',
    // Export lifecycle
    EXPORT_STARTED: 'report_export_started',
    EXPORT_COMPLETED: 'report_export_completed',
    EXPORT_FAILED: 'report_export_failed',
    // Page view (unique user tracking)
    PAGE_VIEWED: 'report_page_viewed',
};
